module.exports = __webpack_public_path__ + "static/media/alert-icon.ce589575.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alert-icon.svg
// module id = 629
// module chunks = 0